module.exports = __webpack_public_path__ + "01.svg?ae857db89b1bb26e7b9188b02435ed64";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_setting/01.svg
// module id = 60
// module chunks = 0